import React from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import DownloadButton from "../../../../Common/FilesRelevent/DownloadButton";
import { getDateFormate } from "../../../../Common/AllDateTimeReleventFormate";
import NotFound from "../../../../CustomComponents/AllLoader/NotFound";
import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";
import DownloadwithDisplayProper from "../../../../Common/FilesRelevent/DownloadwithDisplayProper";
import DisplayFileProper from "../../../../Common/FilesRelevent/DisplayFileProper";

export default function FileListings({ foldervalues }) {


  return (
    <div className="table-responsive">
      <table className="table">
        <tbody>
          {
            Array.isArray(foldervalues?.files) &&
           foldervalues?.files.length != 0 ? 
           <>
            {Array.isArray(foldervalues?.files) &&
            foldervalues?.files?.map((item, index) => (
              <tr key={index} >
                <td>
                  <h5 className="img-border-sec">
                    {/* <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/common/ic_attachment.png`}
                      alt=""
                    /> */}
                    <DisplayFileProper item={item}/>
                    {/* <i class="fa-solid fa-file"></i> */}
                    {item?.name}
                  </h5>
                </td>
                <td>
                  <h6>
                    <img src={item?.profile_image ?item?.profile_image :ProfilePic} alt="" />
                    {item?.first_name} {item?.last_name}
                  </h6>
                </td>
                <td>{getDateFormate(item?.created_on)}</td>
                {/* <td>
                  <p>{getImageSize(item?.file)} mb</p>
                </td> */}
                <td>
                  <div className="action-btn">
                    <DownloadButton file={item} />
                    {/* <button className="btn">
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/common/dots-vertical.svg`}
                        alt=""
                      />
                    </button> */}
                  </div>
                </td>
              </tr>
            ))}
           </>:<NotFound title="No files found" />
          }
         
        </tbody>
      </table>
    </div>
  );
}
